// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_click_to_copy = /** @type {(inputs: {}) => string} */ () => {
	return `Click to copy`
};

const zh_click_to_copy = /** @type {(inputs: {}) => string} */ () => {
	return `点击复制`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const click_to_copy = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.click_to_copy(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("click_to_copy", locale)
	if (locale === "en") return en_click_to_copy(inputs)
	return zh_click_to_copy(inputs)
};